const Index = (props) => {
  return props.children
}

export default Index
